//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../Header";
//Install
import Footer from "../../../Footer";
//Install
import M597I5 from "../../../../Media/Image/022.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Yenilenebilir Enerji : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik Taahhüt, Çevresel Değerleri Koruma, Doğanın Sürdürülebilirliğini Güvence Altına Almak ve Gelecek Kuşaklara Sağlıklı Bir Yaşam Bırakma Sorumluluğu İle, Yenilenebilir Enerji Kaynaklarını Etkin Bir Şekilde Kullanmaktadır."
        //Element
        let URL = "https://temaselektrik.com/sunulan-hizmetler/yenilenebilir-enerji"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Yenilenebilir Enerji"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Yenilenebilir",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            " Enerji"
                                        )
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik, Çevresel Değerleri Koruma, Yaşam Alanlarını Gelecek İçin Koruma ve Gelecek Kuşaklara Sağlıklı Bir Yaşam Bırakma Sorumluluğu İle, Yenilenebilir Enerji Kaynaklarını Etkin Bir Şekilde Kullanmaktadır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Gelişmiş Teknoloji ve Optimize Edilmiş Sistemlerle, Güneş, Rüzgâr ve Diğer Yenilenebilir Enerji Kaynaklarından Maksimum Verim Alınmasını Sağlayacak Çözümler Sunmaktadır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Üretilen ve Tüketilen Enerjinin Etkin, Sürdürülebilir Şekilde Kullanılmasını Sağlayan Sistemler, Müşterilerimize Anahtar Teslimi Olarak Tecrübeli Ekibimiz Tarafından Sağlanmaktadır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik, Yenilenebilir Enerji Alanındaki Çalışmalarını Çevreye Duyarlı ve Yüksek Performanslı Sistemler Tasarlayarak Sürdürmektedir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Yenilenebilir Enerji Hedeflerimiz"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "1. Küresel Yenilenebilir Enerji Lideri Olmak"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "2. Sürdürülebilir Enerjiyi Erişilebilir Kılmak"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "3. Enerjiyi Teknoloji İle Güçlendirmek"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "4. Gelecekte Yaşanabilir Bir Dünya"
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Yenilenebilir Enerji", title: "Yenilenebilir Enerji", src: M597I5, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;